import CryptoJS from 'crypto-js'
import axios from 'axios'
import state from '@/store/module_principal/state'

//Vue.use(CryptoJS)
export default {
  randomString() {
    for (var e = "", t = 32, a = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ", o = t; o > 0; --o) e += a[Math.floor(Math.random() * a.length)];
    return e
  },
  aesEncrypt(e) {
      var t = this.randomString(),
          a = CryptoJS.AES.encrypt(e, CryptoJS.enc.Utf8.parse(t), {mode: CryptoJS.mode.ECB})
      return t + "/" + a.toString()
  },
  aesDencrypt(e) {
      var t = this.randomString(),
          a = CryptoJS.AES.decrypt(e, CryptoJS.enc.Utf8.parse(t), {
              mode: CryptoJS.mode.ECB
          });
      return CryptoJS.enc.Utf8.stringify(a).toString()
  },
  monitorar (usuario, clientinfo, cidade, descricao, procedimento) {
    var info = {
            codigo: usuario.codUsuario,
            username: usuario.nomUsuario.toLowerCase(),
            ip: clientinfo.ip,
            city: clientinfo.city,
            region: clientinfo.region,
            regioncode: clientinfo.region_code,
            country: clientinfo.country,
            countrycode: clientinfo.country_code,
            countryname: clientinfo.country_name,
            latitude: clientinfo.latitude,
            longitude: clientinfo.longitude,
            browsername: clientinfo.browser_name,
            browserversion: clientinfo.browser_version,
            osname: clientinfo.os_name,
            ismobile: clientinfo.is_mobile,
            mobilemodel: clientinfo.mobile_model,
            mobilefactory: clientinfo.mobile_factory,
            cidade: cidade,
            procedimento: procedimento,
            descricao: descricao
        }
    var token = { token: this.aesEncrypt(JSON.stringify(info)) }
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + '/monitorar', token, {
        headers: {
            "content-type": "application/x-www-form-urlencoded"
        }
    }).then(result => result.data)
  },  
}